//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CenterImg from "@/components/centerImg/centerImg.vue";
import LeftRedTitle from "@/components/leftRedTitle/leftRedTitle.vue";
import fixLastFlex from "@/utils/fixLastFlex.js";
import PreviewImg from "@/components/previewImg/previewImg.vue";
export default {
  inject: ["showFooter", "switchHeaderStatus"],
  mounted() {
    // 显示footer
    this.showFooter(true);
    this.switchHeaderStatus(true);
    fixLastFlex(this.patentList, 8);
  },
  head() {
    return {
      script: [
        { src: 'https://hm.baidu.com/hm.js?bca287ea2f695c8758d364d29d58ef85' }
      ]
    }
  },
  data() {
    return {
      // 品质证书
      qualityList: [
        {
          id: 1,
          title: "设计中心",
          tip: "R & D",
          // link:'/detail/adv?moveTo=isoqc',
          link: '/detail/sj',
          hover: false,
          icon: require("../assets/img/system/design.png"),
          bg: require("../assets/img/system/01.png"),
          descript:
            "拥有20年以上经验的资深设计研发团队，提供专业产品设计、模具设计、模流分析等咨询服务",
        },
        {
          id: 2,
          title: "模具制造中心",
          tip: "TOOLING",
          hover: false,
          // link:'/detail/adv?moveTo=isozc',
          link: '/detail/mjzzzx',
          icon: require("../assets/img/system/manufacture.png"),
          bg: require("../assets/img/system/02.png"),
          descript:
            "模具制作经过层层工序严格把关，结合牧野CNC机等尖端设备，达到模具的高精密制作",
        },
        {
          id: 3,
          title: "智能智造工厂",
          tip: "AUTONOMATION",
          hover: false,
          // link:'/detail/adv?moveTo=isogk',
          link: '/detail/zn',
          icon: require("../assets/img/system/prodlction.png"),
          bg: require("../assets/img/system/03.jpg"),
          descript:
            "最专业的生产团队，使用科学严谨的体系管理模式，合理安排生产计划，缩短生产交期",
        },
        {
          id: 4,
          title: "QC 检测中心",
          tip: "QUALITY",
          hover: false,
          // link:'/detail/adv',
          link: '/detail/qcjczx',
          icon: require("../assets/img/system/qc_icon.png"),
          bg: require("../assets/img/system/04.jpg"),
          descript:
            "拥有精密检测仪器，如力丰３Ｄ检测仪，和最严谨的品质管控团队，出厂前严格检测每件产品",
        },
      ],
      certificateList: [
        {
          id: 1,
          title: "医疗 ISO 13485 证书",
          img: require("../assets/img/system/iso13485.png"),
        },
        {
          id: 2,
          title: "ISO 14001 证书",
          img: require("../assets/img/system/iso14001.png"),
        },
        {
          id: 3,
          title: "ISO 9001 QMS 证书",
          img: require("../assets/img/system/iso9001.png"),
        },
        {
          id: 4,
          title: "IATF 16949 证书",
          img: require("../assets/img/system/iatf16949.png"),
        },
      ],
      // 专利证书
      patentList: [
        { id: 1, img: require("../assets/img/system/patent/patent_1.jpg") },
        { id: 3, img: require("../assets/img/system/patent/patent_2.jpg") },
        { id: 4, img: require("../assets/img/system/patent/patent_3.jpg") },
        { id: 5, img: require("../assets/img/system/patent/patent_4.jpg") },
        { id: 6, img: require("../assets/img/system/patent/patent_5.jpg") },
        { id: 7, img: require("../assets/img/system/patent/patent_6.jpg") },
        { id: 8, img: require("../assets/img/system/patent/patent_7.jpg") },
        { id: 9, img: require("../assets/img/system/patent/patent_8.jpg") },
        { id: 10, img: require("../assets/img/system/patent/patent_9.jpg") },
        { id: 11, img: require("../assets/img/system/patent/patent_10.jpg") },
        { id: 12, img: require("../assets/img/system/patent/patent_11.jpg") },
        { id: 13, img: require("../assets/img/system/patent/patent_12.jpg") },
        { id: 14, img: require("../assets/img/system/patent/patent_13.jpg") },
        { id: 15, img: require("../assets/img/system/patent/patent_14.jpg") },
        { id: 16, img: require("../assets/img/system/patent/patent_15.jpg") },
        { id: 17, img: require("../assets/img/system/patent/patent_16.jpg") },
        { id: 18, img: require("../assets/img/system/patent/patent_17.jpg") },
        { id: 19, img: require("../assets/img/system/patent/patent_18.jpg") },
        { id: 20, img: require("../assets/img/system/patent/patent_19.jpg") },
        { id: 21, img: require("../assets/img/system/patent/patent_20.jpg") },
        { id: 22, img: require("../assets/img/system/patent/patent_21.jpg") },
        { id: 23, img: require("../assets/img/system/patent/patent_22.jpg") },
        { id: 24, img: require("../assets/img/system/patent/patent_23.jpg") },
        { id: 25, img: require("../assets/img/system/patent/patent_24.jpg") },
      ],

      qualityList1: [
        {
          id: 1,
          title: "客制化组装效率分析",
          hover: false,
          img: require("../assets/img/detail/adv_2.png"),
          imgAct: require("../assets/img/detail/adv_3.gif"),
        },
        {
          id: 2,
          title: "量产前制程分析",
          hover: false,
          img: require("../assets/img/detail/adv_4.png"),
          imgAct: require("../assets/img/detail/adv_5.gif"),
        },
        {
          id: 3,
          title: "制程组装规划",
          hover: false,
          img: require("../assets/img/detail/adv_6.png"),
          imgAct: require("../assets/img/detail/adv_7.gif"),
        },
        {
          id: 4,
          title: "出货包装规划",
          hover: false,
          img: require("../assets/img/detail/adv_8.png"),
          imgAct: require("../assets/img/detail/adv_9.gif"),
        },
      ],
      // 路径
      src: '',
      // 图片预览组件
      preView: false
    };
  },
  mounted(){

    // 显示footer
    this.showFooter(true)
    // 更改导航条为白色背景及其他
    this.switchHeaderStatus(true)
    const route = this.$route.query
    if (route &&route.anchor === 'certificate'){
      console.log(this.$refs.certificate.$el.offsetTop)
      window.scrollTo(0, this.$refs.certificate.$el.offsetTop - 85)
    }
  },
  methods: {
    // 鼠标移入
    qualityItemmove(param) {
      this.qualityList.forEach((item) => (item.hover = false));
      param.hover = true;
    },
    // 鼠标移出
    qualityItemend(param) {
      param.hover = false;
    },
    qualityItemClick(item){
      const {href} = this.$router.resolve(item.link)
      console.log(href)
      // console.log( href)
      // console.log(location.pathname.replace(/(\/$)/, '') + href)
      // console.log( this.$router.resolve(item.link))
      // window.open(location.pathname.replace(/(\/$)/, '') + href, '_blank')

      window.open(href, '_blank')
      // this.$router.push(item.link)
    },

    enter(param) {
      param.hover = true

    },
    leave(param) {
      param.hover = false
    },
    // 预览事件
    previewClick(src){
      console.log(src);
      this.src = src
      this.preView = true
    }
  },
  components: {
    CenterImg,
    LeftRedTitle,
    PreviewImg,
  },
};
